import React from 'react';
import MetricCard from '../MetricCard';
import {
  Container,
  TitlesContainer,
  SectionTitle,
  CardsContainer,
  MobileBlock,
  DesktopBlock,
  MobileSection,
  DailyMetaHint,
  DailyHeadingRow,
  DailySectionTitle,
  DailyMobileTitleBlock,
} from './styles';

const DAILY_META_EXPLANATION =
  'A meta diária é calculada dividindo a meta mensal pela quantidade de dias do mês.';

export default function MetricsSection({
  title,
  cards,
  dailyTitle,
  dailyCards,
}) {
  const allCards = [...cards, ...(dailyCards || [])];

  return (
    <Container>
      <MobileBlock>
        <MobileSection>
          <SectionTitle $first>{title}</SectionTitle>
          <CardsContainer>
            {cards.map((card, index) => (
              <MetricCard
                key={index}
                icon={card.icon}
                title={card.title}
                value={card.value}
                description={card.description}
              />
            ))}
          </CardsContainer>
        </MobileSection>
        {dailyTitle && dailyCards && dailyCards.length > 0 && (
          <MobileSection>
            <DailyMobileTitleBlock>
              <SectionTitle>{dailyTitle}</SectionTitle>
              <DailyMetaHint>{DAILY_META_EXPLANATION}</DailyMetaHint>
            </DailyMobileTitleBlock>
            <CardsContainer>
              {dailyCards.map((card, index) => (
                <MetricCard
                  key={`daily-${index}`}
                  icon={card.icon}
                  title={card.title}
                  value={card.value}
                  description={card.description}
                />
              ))}
            </CardsContainer>
          </MobileSection>
        )}
      </MobileBlock>
      <DesktopBlock>
        <TitlesContainer>
          <SectionTitle $first>{title}</SectionTitle>
          {dailyTitle && (
            <DailyHeadingRow>
              <DailySectionTitle>{dailyTitle}</DailySectionTitle>
              <DailyMetaHint>{`- ${DAILY_META_EXPLANATION}`}</DailyMetaHint>
            </DailyHeadingRow>
          )}
        </TitlesContainer>
        <CardsContainer>
          {allCards.map((card, index) => (
            <MetricCard
              key={index}
              icon={card.icon}
              title={card.title}
              value={card.value}
              description={card.description}
            />
          ))}
        </CardsContainer>
      </DesktopBlock>
    </Container>
  );
}
